import React, { useEffect, useState } from "react";
import Select from "react-select";

export type Option = {
  value: string;
  label: string;
  name?:string;
};

export interface SelectProps {
  options: Option[];
  name?: string,
  defaultValue?: string | any;
  className?: string;
  styles?: any;
  disabled?: boolean;
  onChange?: (option: Option | null) => void; // Added onChange to props
  onFocus?:(event: React.FocusEvent<HTMLDivElement | HTMLInputElement | HTMLSelectElement>) => void
}

const CommonSelect2: React.FC<SelectProps> = ({ options, name, defaultValue ="", className="", disabled, onChange, onFocus, styles={} }) => {
  const [selectedOption, setSelectedOption] = useState<Option | undefined>(undefined);


  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    const matchedOption = options?.find(opt => opt.value == selectedValue ) || null
    
    setSelectedOption(matchedOption || undefined);
    if (onChange) {
      onChange(matchedOption); 
    }
  };


// useEffect(() => {
//     const initialOption = options.find(opt => opt.value == defaultValue);
//     setSelectedOption(initialOption);
//     // setSelectedOption(defaultValue || undefined);
//   }, [defaultValue, options]);

useEffect(() => {
  if (defaultValue) {
    const initialOption = options.find(opt => opt.value == defaultValue);
    setSelectedOption(initialOption);
  }
}, []);

  
  return (
     <select 
      className={`${className} form-select dropdown-wrapper ${disabled ? "cursor-not-allowed" : ""} `}
      name={name}
      // defaultValue={defaultValue}
      value={selectedOption?.value || ""}
      onFocus={onFocus}
      onChange={handleChange}
      disabled={disabled}
      style={styles}
    >
        <option value="">--Select--</option>
        {options?.map((option)=> {
          return (
            <option key={option?.value} value={option?.value} > 
              {option?.label} 
            </option>
          )
        })}
    </select>
  );
};

export default CommonSelect2;

{/* <option value="">Select Department</option>
  <option value="Finance">Finance</option>
  <option value="Application Development">Application Development</option>
  <option value="IT Management">IT Management</option>
  <option value="Sales">Sales</option>
  <option value="UI/UX">UI/UX</option> */}
  
  {/* <Select
    classNamePrefix="react-select"
    className={className}
    options={options}
    value={selectedOption}
    onChange={handleChange}
    placeholder="Select"
    /> */}
    
    
    
    // const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    //   const selectedValue = event.target.value;
    //   const matchedOption = options?.find(opt => opt.value == selectedValue ) || null
      
    //   setSelectedOption(matchedOption || undefined);
    //   if (onChange) {
    //     onChange(matchedOption); // Call the parent component's handler
    //   }
    // };
    
  